import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api/client';

export type PostLoginActionType = 'transferBasket' | 'checkout';
export interface PostLoginAction {
  type: PostLoginActionType;
  params?: unknown;
}
export const POST_LOGIN_ACTIONS_KEY = 'POST_LOGIN_ACTION';

export const getPostLoginActions = (): PostLoginAction[] => {
  return JSON.parse(localStorage.getItem(POST_LOGIN_ACTIONS_KEY) ?? '[]');
};

export const savePostLoginActions = (actions: PostLoginAction[]) => {
  localStorage.setItem(POST_LOGIN_ACTIONS_KEY, JSON.stringify(actions));
};

export const isAuthorized = (): boolean => {
  return !!getWebStoreApiClient().account;
};
